import { TurnstileWidget } from '@kompare/captcha-react';
import { CaptchaState } from 'src/common/apiGraphql/mutations/useCreateSoWithCaptcha.mutate';
import { i18n } from 'src/common/utils/translate.util';
import { colors } from 'src/theme';
import { Flex } from '../grid';
import { Text } from '../typography';

/**
 * The Turnstile widget plus its copy, rendered above a form's submit buttons while a
 * challenge is due. Spread the `captcha` object from `useCreateSoWithCaptcha` into it;
 * it renders nothing until the API has asked for a captcha, so regular visitors never
 * load Cloudflare's script.
 *
 * The 428 copy is shown while a Managed widget is still auto-verifying (1–2 s), so it
 * uses a neutral colour — in the error colour it reads like a failure. The load-error
 * fallback (blocked CDN, unsupported webview) is a real failure and stays red.
 */
export const CaptchaChallenge = ({ required, message, widgetProps }: CaptchaState) => {
  if (!required) return null;
  return (
    <Flex vertical gap={8} align="center">
      <TurnstileWidget
        {...widgetProps}
        loadErrorFallback={
          <Text type="small" color={colors.error1}>
            {i18n.t('common.messages.error')}
          </Text>
        }
      />
      {message && (
        <Text type="small" color={colors.text3}>
          {message}
        </Text>
      )}
    </Flex>
  );
};
